import React from 'react';
import './LectureList.less';
import {Row, Column, Item} from 'react-plan';
import {Link} from 'react-router';
import { observer } from 'mobx-react';

type Props = {
  courseId: string;
  lectures: Object;
}

const strings = {
  lectureNumber: 'Lecture #',
  lectureName: 'Lecture name',
  duration: 'Duration'
};

@observer(['lectures', 'enrollments'])
class LectureList extends React.Component {

  description: 'List Lectures of a given component.'

  props: Props

  constructor(props: Props) {
    super(props);
  }

  /* Component Custom Methods */
  renderList = () => {
    const lectures = this.props.lectures.getLecturesByCourseId(this.props.courseId);
    let currentCategory = null;
    return lectures.map(([id, lecture]) => {
      const JSX = [];
      const enrollment = this.props.enrollments.lectures.get(id);
      const completed = (enrollment) ? <i className="icon-check" /> : null;
      if (currentCategory !== lecture.category) {
        currentCategory = lecture.category;
        JSX.push(<p className="curriculum-title">{ lecture.category }</p>);
      }
      JSX.push(
        <Row className="row">

          <Link className="no-underline link-row" to={ `/lecture/${id}` }>
            <Row justify="space-between">
              <Item size="5%" >

                <span className="completion">{ completed }</span>

              </Item>
              <Item size="5%" >
                <span data-icon="q" className="icon"></span>
              </Item>
              <Item size="75%" className="">
                { lecture.name }
              </Item>


              <Item className="txt-align-r" size="15%">{ lecture.duration || '' }
              </Item>
            </Row>
          </Link>
        </Row>
      );
      return JSX;
    });
  }
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {
    return (
      <div className="lecture-list">
        <Row className="header">
          <Column>{ strings.lectureName }</Column>
          <Column className="txt-align-r" size="20%">{ strings.duration }</Column>
        </Row>
        { this.renderList() }
      </div>
    );
  }
  /* End React Component LifeCycle Methods */
}

export default LectureList;

//Unit test entry point
export const LectureListTest = LectureList;


/** WEBPACK FOOTER **
 ** ./src/js/lecture/LectureList/LectureList.jsx
 **/